import { ReactivateModal } from '@presentation/components/templates'

type Props = {
  id: string
  onReactivate: () => void
}

const ReactivateFuncaoModal: React.FC<Props> = ({ id, onReactivate }) => {
  const modalConfigs = {
    id,
    path: '/funcoes',
    nameForTitle: 'Função',
    onReactivate
  }

  return <ReactivateModal {...modalConfigs} />
}

export default ReactivateFuncaoModal
